const settings = {
    decimalLength: 2,
    topBarCoins: 2,
    maximumNotices: 50,
};

export default settings;